import React, { useEffect } from 'react';
import cn from 'clsx';
import RCSlider from 'rc-slider';

import SliderTooltip from './components/slider-tootip/slider-tooltip';

import styles from './slider.scss';

interface SliderProps {
  markerPrefix?: string;
  markerSuffix?: string;
  max: number;
  min: number;
  onChange: (value: number) => void;
  showTooltip?: boolean;
  value: number;
}

function Slider(props: SliderProps) {
  const {
    markerPrefix = '',
    markerSuffix = '',
    max,
    min,
    onChange,
    showTooltip = false,
    value: proposedValue
  } = props;
  const value = (() => {
    if (proposedValue < min) {
      return min;
    } else if (proposedValue > max) {
      return max;
    } else {
      return proposedValue;
    }
  })();

  useEffect(() => {
    if (value !== proposedValue) {
      onChange(value);
    }
  });

  return (
    <div
      className={cn(
        showTooltip ? styles['slider-tooltip'] : styles['slider'],
        'slider'
      )}
    >
      <div className={cn(styles['markers'], 'slider__markers')}>
        <span className={cn(styles['marker'], 'slider__marker')}>
          {markerPrefix}
        </span>
        <span className={cn(styles['marker'], 'slider__marker')}>
          {markerSuffix}
        </span>
      </div>
      <RCSlider
        handle={showTooltip ? SliderTooltip : undefined}
        max={max}
        min={min}
        onChange={onChange}
        value={value}
      />
    </div>
  );
}

export default Slider;
